import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { ScrollView } from 'react-native';
import {
  IPreferencesFormState,
  MyPreferencesProps,
  PreferencesComponent,
  PreferencesFormType,
} from './types';
import { myPreferenceStyled as styled } from './styled';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../../components/Image';
import { Text } from '../../components/Text';
import { Footer } from '../../components/Footer';
import PreferencesForm from './components/PreferencesForm';
// import {
//   accountStatementStructure,
//   mailingStructure,
//   pushNotificationStructure,
// } from './constants';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import MyAccountLayout from '../../components/MyAccountLayout/MyAccountLayout';
import PageTitle from '../../components/PageTitle';
import { FONTS } from '../../constants';
import PreferenceApi from '../../services/api/preference.api';
import {
  NotificationPreference,
  PreferenceOption,
} from '../../types/preference.types';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { setHeaderConfigAxios } from '../../services/api/axios';
import { Loading } from '../../components';
import { Alert } from '../../services/alert';
import { NavigationService } from '../../services/navigation';

const MyPreferences: FC<MyPreferencesProps> = ({ navigation }) => {
  const isDesktop = useIsDesktop();
  const auth = useSelector((redux: RootState) => redux.authReducer);
  const [notifications, setNotifications] = useState<NotificationPreference>({
    events: [],
    news: [],
    promotions: [],
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const pushNotificationStructure: PreferencesFormType = useMemo(() => {
    var isAllOn: boolean = true;
    var components: {
      title?: string;
      contents: PreferencesComponent[];
      isFullWitdh?: boolean;
    }[] = [];

    for (const [key, value] of Object.entries(notifications)) {
      components.push({
        title: key,
        isFullWitdh: true,
        contents: value.map((item: PreferenceOption) => {
          if (!Boolean(item.subscribed)) {
            isAllOn = false;
          }
          return {
            id: item.term_id,
            label: item.name,
            value: Boolean(item.subscribed),
          };
        }),
      });
    }

    components.unshift({
      isFullWitdh: true,
      contents: [
        {
          id: 'allNoti',
          label: 'All Push Notifications',
          effectAll: true,
          value: isAllOn,
        },
      ],
    });

    return {
      title: 'Push Notification',
      description:
        "Please select your communication preferences for receiving Push Notifications from the Kowloon Cricket Club. By default, they are set to receive all. However, you can customise which types of push notifications you'd like to subscribe to based on the categories below. \n\nNote: All Members will receive notifications for general Club news and notices.",
      icon: require('../../assets/notices.png'),
      components: components,
    };
  }, [notifications]);

  const initState = useCallback((structure: PreferencesFormType) => {
    return structure.components.map((item) => {
      const contents = item.contents.reduce(
        (acc, content) => ({
          ...acc,
          [content.id]: content.value,
        }),
        {}
      );

      return {
        title: item.title || '',
        contents: contents,
      };
    });
  }, []);

  const getPreference = useCallback(async () => {
    try {
      setIsLoading(true);
      setHeaderConfigAxios(auth.token);
      const res = await PreferenceApi.getPreference();
      if (res.data.cats) {
        setNotifications(res.data.cats);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [auth.token]);

  const handleSubmitData = useCallback(
    async (data: IPreferencesFormState[]) => {
      var submitValues: PreferenceOption[] = [];

      setIsSubmitting(true);
      data.map((item) => {
        for (const [key, value] of Object.entries(item.contents)) {
          if (key == 'allNoti') continue;

          submitValues = [
            ...submitValues,
            {
              term_id: key,
              subscribed: value,
            },
          ];
        }
      });
      PreferenceApi.updatePreference({ cats: submitValues })
        .then((response: any) => {
          Alert.alert('Success', response.data.message);
        })
        .catch((error: any) => {
          Alert.alert('Error', error.message);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    },
    []
  );

  useEffect(() => {
    getPreference();
  }, [getPreference]);

  if (isDesktop()) {
    return (
      <MyAccountLayout
        title="My Preferences"
        current={4}
        icon={require('../../assets/my-preferences.png')}
      >
        {isLoading ? (
          <View style={{ marginTop: 20, marginBottom: 20 }}>
            <Loading />
          </View>
        ) : (
          <View>
            {/* <PreferencesForm
                form={accountStatementStructure}
                initState={initState(accountStatementStructure)}
                onSubmit={(data) => {
                  console.log(data);
                }}
                key={accountStatementStructure.title}
              />
              <PreferencesForm
                form={mailingStructure}
                initState={initState(mailingStructure)}
                onSubmit={(data) => {
                  console.log(data);
                }}
                key={mailingStructure.title}
              /> */}
            <PreferencesForm
              form={pushNotificationStructure}
              initState={initState(pushNotificationStructure)}
              onSubmit={handleSubmitData}
              key={pushNotificationStructure.title}
            />
          </View>
        )}
        {isSubmitting && <Loading isFullScreen={true} />}
      </MyAccountLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styled.container}>
        <PageTitle
          title="My Preferences"
          icon={require('../../assets/my-preferences.png')}
          haveGoBackButton={true}
          handleGoBack={() => {
            NavigationService.push('Root', {
              screen: 'MyAccountTab',
            });
          }}
        />
      </View>
      <View style={styled.container}>
        {isLoading ? (
          <View style={{ marginTop: 20, marginBottom: 20 }}>
            <Loading />
          </View>
        ) : (
          <>
            {/* <PreferencesForm
                form={accountStatementStructure}
                initState={initState(accountStatementStructure)}
                onSubmit={(data) => {
                  console.log(data);
                }}
                key={accountStatementStructure.title}
              />
              <PreferencesForm
                form={mailingStructure}
                initState={initState(mailingStructure)}
                onSubmit={(data) => {
                  console.log(data);
                }}
                key={mailingStructure.title}
              /> */}
            <PreferencesForm
              form={pushNotificationStructure}
              initState={initState(pushNotificationStructure)}
              onSubmit={handleSubmitData}
              key={pushNotificationStructure.title}
            />
          </>
        )}
      </View>
      <Footer />
      {isSubmitting && <Loading isFullScreen={true} />}
    </ScrollView>
  );
};

export default MyPreferences;
